const DEV_MODAL_BUILDS = ['alpha', 'sigma', 'omega', 'gamma', 'bravo'];

/** True for local/dev, inspect, staging, and other test builds — never production. */
export const isNonProductionAppBuild = (): boolean =>
	Boolean(import.meta.env.DEV) ||
	import.meta.env.MODE === 'inspect' ||
	import.meta.env.VITE_APP_BUILD !== 'prod';

export const isDevModalAvailable = (email?: string | null): boolean =>
	(import.meta.env.DEV ||
		import.meta.env.MODE === 'inspect' ||
		DEV_MODAL_BUILDS.includes(import.meta.env.VITE_APP_BUILD)) &&
	Boolean(email);
